<template lang="pug">
v-dialog(:value="value" persistent width='800px')
  v-card
    title-bar(dark) {{ `CANCEL CAMPAIGN: ${getTitle}` }}
    v-flex.pa-4.flex
      span(xs12) 
      | Select contacts to cancel scheduled campaign actions. The campaign is currently running for {{ total }} contact(s).
      .xs12
        v-checkbox(
          v-model='selectAll'
          :label="(selectAll ? 'Deselect' : 'Select') + ' all contacts on campaign'"
          primary
          hide-details
        ) {{ selectAll ? "Deselect" : "Select" }} all contacts on campaign
      div.column-wrapper(xs12)
        div.column(v-for='contact in contacts')
          v-checkbox(
            v-model="contact.isSelected"
            :label="contact | getFullName | replaceBlankName"
            primary
            hide-details
            @click.native="selectContact(contact.id)"
          )
      v-layout.pagination(xs12)
        v-flex.limits
          pagination-limit.mr-4(
            :limits="paginationLimits"
            :current-limit="limit"
            @change:limit="setPageLimit"
            )
        v-flex.pages
          v-pagination(
            :value="getPage"
            :length="pageCount"
            @input="setPage"
            :total-visible="7"
            v-show="pageCount > 1"
          )
    v-card-actions
      v-spacer
      v-btn(flat @click="closeDialog") Close
      v-btn(color="primary" @click="stop" :disabled="disableConfirm") Confirm
</template>

<script>
import TitleBar from '@/Core/components/TitleBar';
import PaginationLimit from '@/Core/components/PaginationLimit';
import getFullName from '@/Core/filters/getFullName';
import replaceBlankName from '@/Core/filters/replaceBlankName';

export default {
  name: "StopContactsModal",
  components: {
    TitleBar,
    PaginationLimit,
  },
  filters: {
    getFullName,
    replaceBlankName,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    contacts: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    skip: {
      type: Number,
      default: 0,
    },
    limit: {
      type: Number,
      default: 15,
    }
  },
  data() {
    return {
      selected: [], 
      selectAll: false, 
      excluded: [],
      paginationLimits: [15, 30, 45, 60],
    };
  },
  watch: {
    selectAll: {
      handler(value) {
        if (!value) {
          this.clearState();
        }
        this.selectAllContacts();
      },
    },
    contacts: {
      handler() {
        this.selectAllContacts();
      },
    },
  },
  computed: {
    getPage() {
      return Math.floor(this.skip / this.limit) + 1;
    },
    pageCount() {
      return Math.ceil(this.total / this.limit) || 0;
    },
    getTitle() {
      return this.total > 1 ? `${this.total} ACTIVE CONTACTS` : `${this.total} ACTIVE CONTACT`;
    },
    disableConfirm() {
      return !this.selectAll && this.selected.length === 0;
    },
  },
  methods: {
    setPage(page) {
      this.$emit('setPage', page);
    },
    setPageLimit(limit) {
      this.$emit('setPageLimit', limit);
    },
    closeDialog() {
      this.$emit('close');
      this.clearState();
    },
    stop() {
      let payload = {
        contacts_ids: this.selected,
        all_contacts: this.selectAll,
        excluded_contacts_ids: this.excluded,
      };
      const contactsSelected = this.selectAll ? this.total - this.excluded.length : this.selected.length;
      const areAllContactsSelected = contactsSelected === this.total;
      this.$emit('stop', payload, contactsSelected, areAllContactsSelected);
      this.clearState();
    },
    selectAllContacts() {
      this.contacts.forEach(contact => {
        contact.isSelected = this.selectAll 
          ? !this.excluded.includes(contact.id)
          : this.selected.includes(contact.id);
      });
    },
    clearState() {
      this.selectAll = false;
      this.selected = [];
      this.excluded = [];
    },
    selectContact(contactId) {
      if (this.selected.includes(contactId)) {
        const i = this.selected.indexOf(contactId);
        this.selected.splice(i, 1);
      } else if (!this.selectAll) {
        this.selected.push(contactId);
        return;
      }

      // Only touch excluded contacts if select all
      if (!this.selectAll) return;

      if (this.excluded.includes(contactId)) {
        const i = this.excluded.indexOf(contactId);
        this.excluded.splice(i, 1);
      } else {
        this.excluded.push(contactId);
      }

      if (this.excluded.length === this.total) {
        this.clearState();
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.column-wrapper {
  max-height: 35vh;
  padding-top: 12px;
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
}

.column {
  width: 33.33%;
  padding: 3px;
}

.pagination {
  height: 60px;
}
</style>
